const PLAYWIRE_SPA_NAVIGATION_FLAG = "__playwireSpaHasNavigated";

export type PlaywireSpaAds = (options: {
  ads: Array<{ selectorId: string; type: string }>;
  countPageview: boolean;
  path: string;
}) => Promise<unknown> | unknown;

type PlaywireWindow = Window & {
  [PLAYWIRE_SPA_NAVIGATION_FLAG]?: boolean;
};

function getPlaywireWindow(): PlaywireWindow | null {
  if (typeof window === "undefined") {
    return null;
  }

  return window as PlaywireWindow;
}

export function markPlaywireSpaNavigation() {
  const playwireWindow = getPlaywireWindow();

  if (!playwireWindow) {
    return;
  }

  playwireWindow[PLAYWIRE_SPA_NAVIGATION_FLAG] = true;
}

export function shouldCountPlaywirePageview() {
  const playwireWindow = getPlaywireWindow();

  return Boolean(playwireWindow?.[PLAYWIRE_SPA_NAVIGATION_FLAG]);
}

export function onPlaywireReady(callback: (spaAds: PlaywireSpaAds) => void) {
  let cancelled = false;

  const run = () => {
    if (cancelled || typeof window.ramp?.spaAds !== "function") return;
    callback(window.ramp.spaAds.bind(window.ramp));
  };

  if (typeof window.ramp?.spaAds === "function") {
    run();
  } else {
    window.ramp = window.ramp || {};
    window.ramp.que = window.ramp.que || [];
    window.ramp.que.push(run);
  }

  return () => {
    cancelled = true;
  };
}
